import { FrameName } from "../config";
import ForestTerrainTileEntity from "./ForestTerrainTileEntity";

class OldForestTerrainTileEntity extends ForestTerrainTileEntity {
	public static readonly frameName = FrameName.OLD_FOREST;
}

export default OldForestTerrainTileEntity;
